export const SHOPIFY_CLIENT_ERROR_MESSAGES = {
  ORDER_EMAIL: "ORDER_EMAIL is not configured",
  INVALID_SHOP: "Received invalid shop argument",
  INSTALLATION_DOMAIN_NOT_DEFINED: "Installation domain not defined",
  CLIENT_NOT_DEFINED: "Shopify client not initialized",
  NO_SESSION: "Could not find session for",
};
